import { Injectable} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

const PAD_LENGTH = -2;

@Injectable()
export class CustomDateAdapter {
  fromModel(value: string): NgbDateStruct
  {
     if (!value)
      return null
     let parts=value.split('-');
     return {year:+parts[0],month:+parts[1],day:+parts[2]} as NgbDateStruct
  }

  toModel(date: NgbDateStruct): string 
  {
    return date ? `${date.year}-${(`0${date.month}`).slice(PAD_LENGTH)}-${(`0${date.day}`).slice(PAD_LENGTH)}` : null
  }

}